import React from "react"
import useFormField from "../../../../hooks/useFormField"

export default function ImageChoiceInput({
  name,
  id,
  options = [],
  label,
  description,
  required,
  showSelectionInputControl,
  allowMultiSelect,
  displayOption,
  globalValue,
  setGlobalValue,
}) {
  const preValue = allowMultiSelect ? [] : ""
  const { value, handleChange } = useFormField(
    preValue,
    () => {},
    globalValue,
    setGlobalValue,
    () => {},
  )

  const handleImageSelect = (e) => {
    const selectedValue = e.target.value
    if (allowMultiSelect) {
      const newValue = value.includes(selectedValue) ? value.filter((val) => val !== selectedValue) : [...value, selectedValue]
      handleChange({ target: { value: newValue } })
    } else {
      handleChange({ target: { value: selectedValue } })
    }
  }

  return (
    <div
      className={`Form__Element FormChoice FormChoice--Image ${displayOption} ${required ? "ValidationRequired" : ""}`}
      data-f-element-name={name}
      data-f-type="choice"
      title={description}
      aria-label={description}
    >
      <fieldset>
        <legend className="Form__Element__Caption">{label}</legend>
        {options.map((option, index) => (
          <label key={index} htmlFor={`${id}_${index}`} className="FormChoice--Image__Item">
            <input
              type={allowMultiSelect ? "checkbox" : "radio"}
              id={`${id}_${index}`}
              name={name}
              value={option.text}
              className="FormChoice__Input"
              data-f-datainput=""
              checked={allowMultiSelect ? value.includes(option.text) : value === option.text}
              onChange={handleImageSelect}
              title={description}
              aria-label={description}
              required={required}
              aria-required={required}
            />
            {showSelectionInputControl && <span className="FormChoice--Image__Item__Caption">{option.text}</span>}
            <img src={option.href} title={option.text} alt={option.text} />
          </label>
        ))}
      </fieldset>
    </div>
  )
}
